import { SET_DATASET } from './mutation-types';

export default {
  [SET_DATASET](state, dataset) {
    state.dataset = dataset;
  },
};
